import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import TradeDemos from "@/components/TradeDemos";
import Portfolio from "@/components/Portfolio";
import Testimonials from "@/components/Testimonials";
import RoiCalculator from "@/components/RoiCalculator";
import Pricing from "@/components/Pricing";
import Process from "@/components/Process";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MobileCta from "@/components/MobileCta";
import TradeDemo from "@/pages/TradeDemo";
import Admin from "@/pages/Admin";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => document.querySelector(window.location.hash)?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);

  return (
    <div className="grain bg-obsidian min-h-screen">
      <Seo
        title="Websites Built for the Trades"
        description="TradeSite Pro builds beautiful, high-converting websites for contractors and trade businesses. See interactive demos, transparent pricing, and examples."
      />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <TradeDemos />
        <Portfolio />
        <Testimonials />
        <RoiCalculator />
        <Pricing />
        <Process />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <MobileCta />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <HelmetProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/trades/:slug" element={<TradeDemo />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
        </HelmetProvider>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121216", border: "1px solid rgba(212,175,55,0.3)", color: "#F8F6F0" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
